import React, { useState } from 'react';
import axios from 'axios'
import { useEffect, useRef } from 'react';

// Add custom styles for modal dimmer
const customStyles = `
  .ui.dimmer {
    background-color: rgba(0, 0, 0, 0.85) !important;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
  }
  
  .ui.page.dimmer {
    background-color: rgba(0, 0, 0, 0.85) !important;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
  }
  
  .ui.blurring.dimmer {
    background-color: rgba(0, 0, 0, 0.85) !important;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
  }
  
  .ui.inverted.dimmer {
    background-color: rgba(0, 0, 0, 0.85) !important;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
  }
  
  /* Add a subtle animation to the dimmer */
  .ui.dimmer.visible {
    animation: dimmerFadeIn 0.3s ease-out;
  }
  
  @keyframes dimmerFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;
// Remove LanguageSelector import - already removed
// import LanguageSelector from './LanguageSelector';
import useTimeTracker from './hooks/useTimeTracker';

import {
    Input,
    Dropdown,  // Keep if used elsewhere
    Form,
    Button,
    Modal,
    Transition,
    Container,
    Label,
    GridRow,
    Icon
} from 'semantic-ui-react'
import { Fragment } from 'react';
import { Message, Confirm } from 'semantic-ui-react';

// import './LabLayout.css'; CAUTION! see notes below
// importing css causes issues when building the project at aws code build
// see app/assets/stylesheets/lab.css
// used at app/views/layouts/lab_layout.html.haml


import SideTabs from './SideTabs'

import { ToastContainer, toast } from 'react-toastify';
import PageVisibility from 'react-page-visibility';
import ActionMessage from './ActionMessage'
// Remove Zoom import since it's now handled in RightSection
// import Zoom from './Zoom'
import UserCard from './Card'
import CircuitName from './CircuitName'
import ClassRooms from './ClassRooms'
import ShowOff from './ShowOff'
import SignedInAd from './SignedInAd'
import DropdownFile from './File'

import IcCreatorWrapper from './ic-creator/src/IcCreatorWrapper';

import {
    Checkbox,
    Grid,
    Advertisement,
    Header,
    Image,
    Menu,
    Segment,
    Sidebar
} from 'semantic-ui-react'
import Share from "./Share";
import Chart from "./Chart";

import FloattingButton from "./FloattingButton";
import { BasicAd } from "./BasicAd";
import RightSection from './Header/components/RightSection';
import LeftPanel from './LeftPanel/LeftPanel';
import AISideTabs from './Header/components/RightSection/AISideTabs';
import SubscriptionModal from './components/SubscriptionModal';

function LabLayout(props) {
    // Add custom styles to the document head
    useEffect(() => {
        const styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.appendChild(document.createTextNode(customStyles));
        document.head.appendChild(styleElement);
        
        return () => {
            document.head.removeChild(styleElement);
        };
    }, []);
    
    const { current_locale } = props;
    const { allow_chat } = props;
    const { available_chats_count } = props;
    const { user_ics } = props;
    const { official_ics } = props;
    const { experiment_owner_ics } = props;
    const { is_paid_subscriber } = props;
    let last_visiblity_change = null;
    let background = '#000000';
    let forecolor = '#ffffff';
    
    // Constants for time thresholds
    const PRIMARY_THRESHOLD = 2.5 * 60 * 60; // 2 hours
    const SECONDARY_THRESHOLD = 3.0 * 60 * 60; // 2.5 hours
    const [time_at_vsible, setTime_at_vsible] = useState(0);
    const [zoomValue, setZoomValue] = useState(1);

    const [is_labLoaded, setLabLoaded] = useState(false);
    
    const [is_public, setPublic] = useState(false);
    const [isSaveOpened, setSaveOpened] = useState(false);
    const [isSaveSubmited, setSaveSubmited] = useState(false);

    const [isSaving, setIsSaving] = useState(false);
    const [isAnswering, setIsAnswering] = useState(false);
    const [isEditingAssignment, setIsEditingAssignment] = useState(false);
    const [isIcCreatorOpen, setIcCreatorOpen] = useState(false);

    const [isRetryOpened, setRetryOpened] = useState(false);
    const [customErrorOpened, setCustomError] = useState(false);

    const [share_opened, setShareOpen] = useState(false);

    const [mark, setMark] = useState(0);
    const [markCaption, setMarkCaption] = useState("");

    const [title, setTitle] = useState("");
    const [titleBefore, setTitleBefore] = useState("");
    const [experiment_id, setExperiment_id] = useState("");

    const [description, setDescription] = useState("");
    const [question, setQuestion] = useState("");
    const [analysisMode, setAnalysisMode] = useState('time_domain');
    const [DCSweepSources, setDCSweepSources] = useState([]);
    const [metricNodes, setMetricNodes] = useState([]);
    const [pickedDCSweepSource, setPickedDCSweepSource] = useState([]);
    
    const [submitAnswerDialogShown, showSubmitedAnswerDialog] = useState(false);

    const [aiVisible, setAiVisible] = useState(() => {
        return (props.show_ai_chat && !props.experiment_id) || props.ai_chat_visible === true;
    });

    const [visible, setVisible] = React.useState(false)
    const [nodes, setNodes] = React.useState([])
    const [selectedNodes, setSelectedNodes] = React.useState({labels:[],datasets:[]})
    const [initialChecksSelected, setInitialChecksSelected] = React.useState([])
    const [isChartLoading, setChartLoading] = React.useState(false)
    const [show_ads, setShowAds] = React.useState(true)
    const [chart_volts_data, setSelectedVoltsValues] = React.useState({labels:[],datasets:[]})
    const [chart_VSweep_values, setVSweepValues] = React.useState({labels:[],datasets:[]})
    const [chart_amperes_data, setSelectedAmperesValues] = React.useState({labels:[],datasets:[]})
    const [labLoadingTimerHandler, setLabLoadingTimerHandler] = React.useState(null);

    const [currentable_names, set_currentable_names] = React.useState([])
    const [userProjects, setuserProjects] = React.useState([])
    const [show_ic_creator, setShowIcCreator] = React.useState(false)
    
    const [initialLocation, setInitialLocation] = React.useState({ x: 500, y: window.innerHeight- 250 })

    const [currentMouseEvent, setCurrentMouseEvent] = React.useState('up')

    
    const [user, setUser] = React.useState(props.user)
    const [submittedAt, setSubmittedAt] = React.useState(null)
    const [submission, setSubmision] = React.useState(null)
    const [labHeight, setLabHeight] = React.useState(500)
    const [isTeacher, setIsTeacher] = React.useState(null)
    const [circuit, setCircuit] = React.useState({})
    
    // State for subscription modal
    const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

    // Track if we should show the modal based on thresholds
    const [shouldShowModalForPrimary, setShouldShowModalForPrimary] = useState(true);
    const [shouldShowModalForSecondary, setShouldShowModalForSecondary] = useState(true);

    // Track time spent on the lab page
    const {
        elapsedTime,
        formattedTime,
        thresholdReached,
        secondaryThresholdReached,
        resetPrimaryThreshold,
        resetSecondaryThreshold
    } = useTimeTracker({
        key: `lab_timez__`,
        threshold: PRIMARY_THRESHOLD,
        secondaryThreshold: SECONDARY_THRESHOLD,
        trackWhenHidden: false,
        isLabLoaded: is_labLoaded, // Pass the state here
        onThresholdReached: (time) => {
            // Just log, we'll handle showing the modal in useEffect
            //console.log(`Primary time threshold reached: ${time} seconds spent on lab`);
            
            // For subscribed users, just show a notification
            if (is_paid_subscriber) {
                // instance("show_lab_alert", {
                //     text: `You've been working on this lab for ${PRIMARY_THRESHOLD} seconds!`,
                //     seconds: 5
                // });
            }
        },
        onSecondaryThresholdReached: (time) => {
            // Just log, we'll handle showing the modal in useEffect
            //console.log(`Secondary time threshold reached: ${time} seconds spent on lab`);
        }
    });

    // Handle showing the modal based on thresholds
    useEffect(() => {
        // Only for non-subscribers
        if (is_paid_subscriber) return;
        
        // Show modal for secondary threshold if we should
        if (secondaryThresholdReached && shouldShowModalForSecondary) {
            setShowSubscriptionModal(true);
            return;
        }
        
        // Show modal for primary threshold if we should
        if (thresholdReached && shouldShowModalForPrimary) {
            setShowSubscriptionModal(true);
        }
    }, [thresholdReached, secondaryThresholdReached, shouldShowModalForPrimary, shouldShowModalForSecondary, is_paid_subscriber]);

    useEffect(() => {
        if (showSubscriptionModal) {
            if (typeof gtag === "function") {
                gtag("event", "view_subscription_modal", { "event_category": "Lab", "event_label": "In Lab"});                
            }
        }
    }, [showSubscriptionModal]);

    const [userMenu, setUserMenu] = React.useState(() => {
        return Array.isArray(props.userMenu) ? props.userMenu : [];
    });
    const [is_subscription_active, setis_subscription_active] = React.useState(false)
    const [restrict_save, setRestrict_save] = React.useState(false)
    const [within_trial_period, setwithin_trial_period] = React.useState(false)        
    const [is_user_signed_in, setis_user_signed_in] = React.useState(false)


    const [triedToSave, setTriedToSave] = React.useState(0)

    const [currentSlide, setCurrentSlide] = React.useState(0)

    const [useNGSpice, setUseNGSpice] = useState(false)
    const [NGSpiceNetList, setNGSpiceNetList] = useState("")
    const [limited, setLimited] = useState(false);
    const [cta, setCTA] = useState(null);
    const [limitation, setLimitation] = useState(false);

    const [descriptionShown, setDescriptionShown] = useState(false)

    const force_show_thumbs = true;
    const show_save_buttons = ((action_name == 'lab' || (user && props.creator && user.id == props.creator.id))) && is_labLoaded;
    const isResubmit = () => {
        return props.submission != null && props.submission.submitted_at != null && props.submission.assignment.settings.resubmit_allowed
    }
    
    const ProfileDropdown = ({ user, userMenu, userMenuChange }) => {
        const trigger = (avatar, name) => (
            <span className="profile-trigger">
                <img src={avatar} alt={name} className="ui avatar image" />
                {/* <span>{name}</span> */}
            </span>
        );
    
        const renderMenuItem = (menu, index, totalItems) => {
            const isEdgeItem = index === 0 || index === totalItems - 1;
            
            if (isEdgeItem) {
                return menu;
            }
    
            return {
                ...menu,
                key: `${menu.key}${index}`,
                onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    userMenuChange(null, { value: menu.value });
                },
                content: (
                    <div 
                        className="item"
                        role="option"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            userMenuChange(null, { value: menu.value });
                        }}
                    >
                        <span className="text">
                            <a 
                                href={menu.value}
                                style={{ color: '#000000' }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    userMenuChange(null, { value: menu.value });
                                }}
                            >
                                {menu.text}
                            </a>
                        </span>
                    </div>
                ),
            };
        };
    
        return (
            <Dropdown
                key="profileMenu"
                onChange={userMenuChange}
                pointing="right"
                trigger={trigger(user.avatar, user.name)}
                options={userMenu.map((menu, index) => 
                    renderMenuItem(menu, index, userMenu.length)
                )}
                onClick={(e) => e.stopPropagation()}
                onBlur={(e) => {
                    // Prevent immediate closing when clicking inside
                    if (e.currentTarget.contains(e.relatedTarget)) {
                        e.preventDefault();
                    }
                }}
            />
        );
    };

    const texts = [
        "Teachers and Students: Access Premium Tools – Upgrade Today!",
        "Don't miss out on our latest features and updates!",
        "Join now and get exclusive access to new tools and resources!"
      ];

    const instance = (fun, arg = null) => {
        // setUseNGSpice true, false
        // setNGSpiceNetList string
        if (fun == "setEditingAssignment") {
            setIsEditingAssignment(arg);
            arg ? $("react-lab-holder").show() : $("react-lab-holder").hide();
            if (arg) setVisible(true);
            setTimeout(() => setLabHeightProperly(), 1);
        }
        if (fun == "clearDescription") {
            setDescription("");
        }
        if (fun == "saveAssignment") {
            save(arg[0], arg[1])
        }

        if (fun == "setUseNGSpice") {

            if (arg && props.is_mobile == false)
                setTimeout(() => {
                    setVisible(true);
                    setUseNGSpice(arg);
                }, 1000);
        }

        if (fun == "setNGSpiceNetList") setNGSpiceNetList(arg);
        if (fun == "show_lab_alert") {
            const showLabAlert = (text, seconds) => {
                toast.info(text, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: seconds * 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            };
            showLabAlert(arg.text, arg.seconds);
        }


        if (fun == "start_limited") {
            setLimited(true);
            setLimitation(true);
        }

        if (fun == "show_limitation") {
            setLimited(true);
            setLimitation(true);
            setTimeout(() => {
                setLimited(false);
                window.thumbs.setCurrentMouseEvent('up');
            }, 500);
        }
    }

    function now() {
        return (new Date()).getTime()
    }

    function validCircuitName(aTitle) {
        return aTitle && aTitle.length > 3 && aTitle.length < 256
    }

    function usePrevious(value) {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    }

    const wasSaveOpened = usePrevious(isSaveOpened)
    if (wasSaveOpened && !isSaveOpened) {
        window.disable_haxe_events = false;
    }
    if (wasSaveOpened === false && isSaveOpened) {
        window.disable_haxe_events = true;
    }

    function userMenuChange(e, data) {
        if (!data || !data.value) return;
        
        if (data.value === "logout") {
            document.getElementById("logout").submit();
        } else {
            window.location = data.value;
        }
    }

    function onZoomMenuChange(e, data) {
        const newZoomValue = Math.max(0.1, Math.min(5, data.value));
        if (window.thumbs && window.thumbs.lab) {
            window.thumbs.lab("newZoom", newZoomValue, [$("#lab-div-id").width(), $("#lab-div-id").height()]);
            setZoomValue(newZoomValue);
        }
    }

    //called when user click Yes on submit answer dialog that appears after auto-save, ANSWER btn ->SAVE btn ->DIALOG->YES btn
    function submitAnswer(aIsRetry = false) {
        if (!user) {
            toast.error(l.please_sign_in_to_submit_answer, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
                hideProgressBar: true
            });
            return;
        }

        showSubmitedAnswerDialog(false);
        //1. Save the current experiment
        save(null, () => {
            // submit the answer now

            setIsAnswering(true);
            setIsSaving(true);
            setSaveOpened(false);
            setRetryOpened(false);
            setCustomError(false);

            // Refresh thumb before submitting
            window.thumbs.refresh_current_thumb();

            let saving_notification_id = toast.loading(l.submiting_answer + '...', { autoClose: false });                        
            setTimeout(() => setLabHeightProperly(), 1);

            const payload = { 
                submission_id: submission.id,
                answer: mark,
                retry: aIsRetry,
                lab_state: window.thumbs.lab_state()  // Add lab state to payload
            };


            axios.post("/api/submit-answer", payload)
                .then(response => {
                    //hide saving progress                    
                    setIsSaving(false);
                    setIsAnswering(false);
                    setSubmittedAt(response.data.submitted_at);
                    
                    // Show success notification

                    toast.update(saving_notification_id, { 
                        isLoading: false, 
                        type: "success", 
                        render: l.your_answer_has_been_saved, 
                        closeButton: true, 
                        hideProgressBar: true 
                    });                    
                    setLabHeightProperly();

                    // Handle resubmission case
                    if (aIsRetry && response.data.status === 200) {
                        setRetryOpened(false);
                    }
                })
                .catch(error => {
                    toast.update(saving_notification_id, { 
                        isLoading: false, 
                        type: "error", 
                        render: l.error_submitting_answer, 
                        autoClose: 2000, 
                        hideProgressBar: true 
                    });                                        

                    setLabHeightProperly();
                    if (error.response.data.status == 900) {
                        setCustomError(true);
                        setIsSaving(false);
                        setIsAnswering(false);
                    } else {
                        setRetryOpened(true);
                    }
                });
        });
    }

    function onSave(saveAs) {
        if (user) {                        
            const trial_finished = !is_subscription_active && !within_trial_period;
            if (trial_finished || restrict_save ) {
                if (restrict_save && !trial_finished){
                    if (typeof gtag === "function")
                        gtag('event', 'restrict_save', { 'event_category': 'sales', 'event_label': "Save" });                        
                }
                instance("show_limitation");
                return;
            }
            setTriedToSave(0)
            window.save_as = saveAs;
            window.thumbs.sync();
            
            com.clientside.main.Html5Bootstrap.jsCall("prepare_thumbs_capture");

            

            
            setTimeout(() => {
                window.thumbs.refresh_current_thumb();
            }, 100);
            

            setSaveSubmited(false);
            setTitleBefore(title);
            setSaveOpened(true);
        } else {
            let offline_circuit = window.thumbs.lab_state()
            localStorage.setItem('offlineCircuit', JSON.stringify(offline_circuit));
            localStorage.setItem('triedToSave', true);
            setTriedToSave(1)
        }
    }


    function saveMark() {
        setMarkCaption("Saving...")
        setIsSaving(true)
        const payload = { submission_id: submission.id, mark }

        axios.post("/api/classroom/store-mark", payload)
            .then(response => {
                //hide saving progress
                setMarkCaption("Saved!")
                setIsSaving(false)
                {
                    toast.info(l.mark_saved_successfully, { autoClose: 1000 * 3})                    
                }
            }
            )
            .catch(error => {
                setMarkCaption("Retry saving")
                setIsSaving(false)
                toast.warning(l.error_saving_mark, { autoClose: 1000 * 4})                                                    
            })
    }

    function save(assignment_id = null, success_callback = null, aCallSuccessDirectly = false) {
        if (aCallSuccessDirectly) {
            success_callback();
        } else {
            
            const isAssignmentCall = assignment_id != null;

            if (!isAssignmentCall && !submission && !validCircuitName(title)) {
                setSaveSubmited(true)
                return false
            }
            setIsAnswering(false)
            setIsSaving(true)
            setSaveOpened(false)
            setRetryOpened(false)
            let circuits = [...window.thumbs.state.slides]
            let tags = [...window.thumbs.state.tags]
            circuits = circuits.map((slide, index) => ({ annotation_texts: slide.annotation_texts, circuit: slide.data, text: slide.text }))            
            
            let saving_notification_id = null;
            // if (!isAssignmentCall) 
            {
                saving_notification_id = toast.loading(l.saving_circuit + '...', { autoClose: false });                
            }
            
            setTimeout(() => setLabHeightProperly(), 1);

            const thumbnail_base64_data = window.thumbs.state.slides[window.thumbs.state.current_slide].base64_shapshot;

            const payload = {
                tags: tags,
                assignment_id: assignment_id,
                experiment_id,
                temp_experiment_id: !experiment_id ? window.temp_experiment_id : undefined,
                save_as: window.save_as,
                circuits,
                public: is_public,
                title: isAssignmentCall ? "Assignment with id:" + assignment_id.toString() : title,
                thumbnail_base64_data,
                ai_chat_visible: aiVisible
            }

            axios.post("/api/store", payload)
                .then(response => {
                    //hide saving progress
                    // if (!isAssignmentCall) toast.dismiss();
                    setIsSaving(false)
                    setIsAnswering(false)
                    setExperiment_id(response.data.experiment_id)
                    // setCircuit({...circuit, share_url: response.data.share_url, lab_title: response.data.lab_title})
                    setCircuit(response.data.lab_props.circuit)

                    window.lab_props = response.data.lab_props;
                    document.title = payload.title;
                    com.clientside.main.Html5Bootstrap.jsCall("lab_got_saved");
                    // The parameters are the same as pushState.
                    if (!isAssignmentCall)
                    history.replaceState({page: 1}, payload.title, response.data.url);                    
                    // Show success notification
                    //if (!isAssignmentCall)                    
                    toast.update(saving_notification_id, { isLoading: false, type: "success", render: l.your_circuit_has_been_saved, autoClose: 2000, hideProgressBar: true });
                    setLabHeightProperly();
                    if (success_callback != null)
                        success_callback();

                }
                )
                .catch(error => {
                    com.clientside.main.Html5Bootstrap.jsCall("lab_got_saved");
                    toast.update(saving_notification_id, { isLoading: false, type: "error", render: l.error_saving_circuit, autoClose: 4000, hideProgressBar: true });                                        
                    setLabHeightProperly();
                    if (error.response.data.status == 900) {
                        setCustomError(true);
                        setIsSaving(false);
                    } else {
                        setRetryOpened(true);
                    }
                });
        }
    };

    React.useEffect(() => {
        // Set initial height and adjust when resizing
        const handleResize = () => {
            setLabHeightProperly();
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Call initially to set height

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    React.useEffect(() => {
        // Initialize here:

        // const isAtMaxWidth = screen.availWidth - window.innerWidth === 0
        // const screenPixelRatio = (window.outerWidth - 8) / window.innerWidth
        // const isAtDefaultZoom = screenPixelRatio > 0.92 && screenPixelRatio <= 1.10
        // const isMaximizedAndDefaultZoom = isAtMaxWidth && isAtDefaultZoom
        // const isFullscreen = window.outerWidth == screen.width && window.outerHeight == screen.height

        
        if (is_labLoaded && props.session.cta != null ){
            setLimitation(true);
            setCTA(props.session.cta);
            setLimited(true);    
        }
        
        // Add beforeunload event handler
        const handleBeforeUnload = (e) => {
            if (window.thumbs && window.thumbs.lab_state) {
                const message = "Make sure current circuit is saved. Do you want to leave?";
                e.returnValue = message;
                return message;
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        
        setSubmision(props.submission)
        setIsTeacher(props.isTeacher)
        setCircuit(props.circuit)
        setShowAds(props.show_ads)        
        setShowIcCreator(props.show_ic_creator)        
        setis_subscription_active(props.session.is_subscription_active)
        setwithin_trial_period(props.session.within_trial_period)        
        setRestrict_save(props.session.restrict_save)
        setis_user_signed_in(props.session.is_user_signed_in)

        setMarkCaption(l.set_mark)
        if (props.submission) {
            setMark(props.submission.mark == null ? 0 : props.submission.mark)
            setSubmittedAt(props.submission.submitted_at)
        }
        window.reading_precision = props.reading_precision;
        window.is_mosfet_new = props.is_mosfet_new;
        window.is_ldr_new = props.is_ldr_new;
        window.is_555_new = props.is_555_new;
        window.is_bell_new = props.is_bell_new;
        window.lab_props = props;
        window.view_only_mode = "false";
        if (window.lab_props.submission != null) {
            window.add_new_components_allowed = props.submission.assignment.settings.add_new_components_allowed ? 'true' : 'false'
            window.property_inspector_hidden = props.submission.assignment.settings.property_inspector_hidden ? 'true' : 'false';
            window.current_hidden = props.submission.assignment.settings.current_hidden ? 'true' : 'false';
        }
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);


        window.labLayout = instance;
        $('textarea#description').focus(function () {
            window.disable_haxe_events = true;
        });
        $('textarea#description').on('blur', function (e) {
            window.disable_haxe_events = false;
            window.thumbs.sync();
        });




        window.disable_haxe_events = false;
        setLabLoaded(false)        
        setExperiment_id(props.experiment_id)

        setTitle(props.title)
        setuserProjects(props.userProjects)        
        setPublic(props.is_public)
        setTriedToSave(0)
        window.embedLab();

        // Set initial AI chat visibility based on both conditions
        if ((props.show_ai_chat && !props.experiment_id) || props.ai_chat_visible === true) {
            setVisible(false);  // Close notes panel if open
            setAiVisible(true); // Show AI panel
        }

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    // The useTimeTracker hook now handles logging internally
    // We don't need a separate effect for logging

    // Consolidated beforeunload handler
    useEffect(() => {
        // Set initial height and adjust when resizing
        const handleBeforeUnload = (e) => {
            const message = "Changes you made may not be saved. Are you sure you want to leave?";
            e.preventDefault();
            e.returnValue = message;
            return message;
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [is_labLoaded]); // Add is_labLoaded as a dependency to reattach the listener

    // Check lab height every 100ms until loaded
    useEffect(() => {
        if (!is_labLoaded) {
            const intervalId = setInterval(() => {
                setLabHeightProperly();
            }, 100);

            // Cleanup interval when component unmounts or when is_labLoaded becomes true
            return () => clearInterval(intervalId);
        }
    }, [is_labLoaded]);

    function user_call_response(response) {
        setUser(response.data.user)
        const menuData = response.data.userMenu;
        setUserMenu(Array.isArray(menuData) ? menuData : []);              
        setShowIcCreator(response.data['lab_props'].show_ic_creator)
        setis_subscription_active(response.data['session'].is_subscription_active)
        setwithin_trial_period(response.data['session'].within_trial_period)                
        setRestrict_save(response.data['session'].restrict_save);
        setis_user_signed_in(response.data['session'].is_user_signed_in);
        setShowAds(response.data['session'].show_ads);
        com.clientside.main.Html5Bootstrap.setSubscription(response.data['session'].is_subscription_active);
        com.clientside.main.Html5Bootstrap.setSignedIn(response.data['session'].is_user_signed_in);
        com.clientside.main.Html5Bootstrap.jsCall("within_trial_period", response.data['session'].within_trial_period);
        setLabHeightProperly();
    }
    // Add this state at the top of your component
    const [lastSimulationErrorTime, setLastSimulationErrorTime] = useState(0);

    // Replace the existing setSimulationError function with this:
    function setSimulationError(error) {
        const now = Date.now();
        if (now - lastSimulationErrorTime >= 5000) {
            toast.error(l.error_simulating_circuit, {
                autoClose: 4000, // Toast will close after 5000 milliseconds (5 seconds)
                hideProgressBar: true, // Optionally, show the progress bar while the toast is visible
                backgroundColor: '#ff0000'
            });
            setLastSimulationErrorTime(now);
        }
    }
    function onLabLoaded() {
        com.clientside.main.Html5Bootstrap.setSubscription(is_subscription_active);
        com.clientside.main.Html5Bootstrap.setSignedIn(is_user_signed_in);
        com.clientside.main.Html5Bootstrap.jsCall("within_trial_period", within_trial_period);                
        window.thumbs.lab("setPlotLocation", initialLocation);

        setLabHeightProperly();
        setLabLoaded(true); // Ensure this is set when the lab is ready

    }
    function setLabHeightProperly(){

        
        const div = document.querySelector('#lab-and-description-side');
        if (!div) return; // Guard clause if element doesn't exist
        
        const rect = div.getBoundingClientRect();        
        const topPosition = rect.top;
        const lab_div = document.querySelector('#lab-div-id');
        const firstChild = lab_div?.firstChild;
        if (firstChild) {
            firstChild.style.padding = '0px';
        }
        setLabHeight(`calc(100vh - ${topPosition+5}px)`);


        if (!is_labLoaded && labLoadingTimerHandler){
            clearTimeout(labLoadingTimerHandler);
            setLabLoadingTimerHandler(null);
        }
    }
    function handleVisibilityChange(isVisible) {
        if (last_visiblity_change == isVisible) return;
        last_visiblity_change = isVisible;

        // When tab becomes visible, check subscription modal conditions
        if (isVisible) {
            // Check if we should show the subscription modal based on thresholds
            // Only for non-subscribers
            if (!is_paid_subscriber) {
                // Show modal for secondary threshold if we should
                if (secondaryThresholdReached && shouldShowModalForSecondary) {
                    setShowSubscriptionModal(true);
                }
                // Show modal for primary threshold if we should
                else if (thresholdReached && shouldShowModalForPrimary) {
                    setShowSubscriptionModal(true);
                }
            }
            
            // Continue with existing user check logic
            if (!user) {
                axios.post("/api/current-user.json", {})
                    .then(response => {
                        user_call_response(response);
                        // enhancement: show save dialog now incase he has tried to save when he was not signed in yet
                    }
                    )
                    .catch(error => {
                        setis_subscription_active(false)
                        setwithin_trial_period(false)
                        setis_user_signed_in(false)
                        setTimeout(() => setLabHeightProperly(), 1);
                        com.clientside.main.Html5Bootstrap.setSubscription(false);
                        com.clientside.main.Html5Bootstrap.setSignedIn(false);
                        com.clientside.main.Html5Bootstrap.jsCall("within_trial_period", false);
                    })
            }
            if (user) {
                axios.post("/api/current-user.json", {})
                    .then(response => {
                        if (response.data.user.id != user.id) {
                            window.location = domain_url
                        } else {
                            user_call_response(response);
                        }
                    }
                    )
                    .catch(error => {
                        if (error.response.status == 401) {
                            setSubmision(null)
                            setUser(null)
                            setUserMenu(null)

                            setis_subscription_active(false)
                            setwithin_trial_period(false)
                            setis_user_signed_in(false)
                            setTimeout(() => setLabHeightProperly(), 1);
                            com.clientside.main.Html5Bootstrap.setSubscription(false);
                            com.clientside.main.Html5Bootstrap.setSignedIn(false);
                            com.clientside.main.Html5Bootstrap.jsCall("within_trial_period", false);
                        }
                    })
            }
        }
    }

    const contextClass = {
        success: 'toast-success',
        error: 'toast-error',
        info: 'toast-info',
        warning: 'toast-warning',
        default: 'toast-default',
        dark: 'toast-dark',
      };
                
      
    // Add default localization strings
    const l = props.l || window.l || {
        save_circuit: 'Save Circuit',
        save_as: 'Save As',
        please_sign_in_to_submit_answer: 'Please sign in to submit answer',
        submiting_answer: 'Submitting answer...',
        your_answer_has_been_saved: 'Your answer has been saved',
        error_submitting_answer: 'Error submitting answer',
        mark_saved_successfully: 'Mark saved successfully',
        error_saving_mark: 'Error saving mark',
        error_simulating_circuit: 'Error simulating circuit',
        saving_circuit: 'Saving circuit...',
        your_circuit_has_been_saved: 'Your circuit has been saved',
        error_saving_circuit: 'Error saving circuit',
        circuit_invalid_name: 'Invalid circuit name',
        circuit_name: 'Circuit name',
        circuit_name_0: 'Circuit name must be at least 4 characters long',
        circuit_name_1: 'Circuit name must be less than 256 characters long',
        public: 'Public',
        new: 'New',
        save: 'Save',
        save_as: 'Save As',
        cancel: 'Cancel',
        share: 'Share',
        you_are_not_sigend_in: 'You are not signed in',
        create_account_to: 'Create an account to save your circuits',
        sign_in: 'Sign in',
        retry: 'Retry',
        error_submit_answer: 'Error submitting answer',
        error_saving_circuit: 'Error saving circuit',
        set_mark: 'Set mark',
        resubmit_answer: 'Resubmit answer',
        submit_answer: 'Submit answer',
        you_can_not_edit_your_work_after_submission: 'You can not edit your work after submission',
        maximum_circuits_number_reached: 'Maximum circuits number reached!',
        you_can_not_save_more_than_the_number_of_circuits_you_have_saved_so_far_contact_us_to_ask_for_remove_limitation: 'You can not save more than the number of circuits you have saved so far, contact us to ask for remove limitation.',
        or_you_can_remove_some_circuits_that_you_do_not_need_to_keep_and_try_again: 'Or you can remove some circuits that you do not need to keep and try again.',
        ok: 'OK'
    };

    return (
      
        <PageVisibility onChange={handleVisibilityChange}>
            <>
                
                {!isEditingAssignment && <FloattingButton is_user_signed_in={is_user_signed_in} setTriedToSave={setTriedToSave} />}
                
                {/* Share Component */}
                <Share 
                    opened={share_opened}
                    circuit={circuit}
                    setShareOpen={setShareOpen}
                    is_labLoaded={is_labLoaded}
                    isSaving={isSaving}
                />

                {nodes.length > 0 &&
                <Chart currentMouseEvent={currentMouseEvent} 
                analysisMode={analysisMode}
                setPickedDcSweepSource={setPickedDCSweepSource}
                pickedDCSweepSource={pickedDCSweepSource}
                DCSweepSources={DCSweepSources}                
                setAnalysisMode={setAnalysisMode}                
                initialLocation={initialLocation} 
                setChartLoading={setChartLoading} 
                isChartLoading={isChartLoading}
                initialSelectedLabels={initialChecksSelected} 
                setSelectedVoltsValues={setSelectedVoltsValues} 
                setSelectedAmperesValues={setSelectedAmperesValues} 
                chart_volts_data={chart_volts_data} 
                chart_VSweep_values={chart_VSweep_values} 
                chart_amperes_data={chart_amperes_data} 
                setSelectedNodes={setSelectedNodes} 
                nodes={nodes}
                setNodes={setNodes} 
                currentable_names={currentable_names}
                metricNodes={metricNodes}                
                />

                }
                
            {!isEditingAssignment && <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                />}

                {/* // TOP MENU */!isEditingAssignment && <>
                    <Grid stackable={true} id="top-bar" verticalAlign='middle' style={{ backgroundColor: props.topBarColor, minHeight: 70, paddingTop: 5 }}>

                        <Grid.Row columns={4} style={{ paddingTop: 10, paddingBottom: 2 }}>

                            {/* LOGO */
                            props.logo_path.indexOf("CircoalreS") != -1 ?
                            <Grid.Column key="logo" width={3} className="middle aligned" style={{ bottom: 0, paddingBottom: 0, maxHeight: 38, maxWidth: 200 }}>
                            <a href={props.home_path}>
                              <Image src={props.logo_path} style={{ filter: 'invert()', height: '100%', marginLeft: 6, maxHeight: '38px', float: 'left' }} />
                              <div style={{display: 'inline', color: 'gray', fontSize:10, verticalAlign: 'middle', marginLeft: '10px', position: 'absolute', top: '50%', transform: 'translateY(-50%)'}}>Powered by DCACLab</div>
                            </a>
                          </Grid.Column>
                                :
                                <Grid.Column key="logo" width={3} className="middle aligned" style={{ bottom: 0, paddingBottom: 0, minWidth: 200, maxHeight: 38, maxWidth: 200 }}>
                                    <a href={props.home_path}>
                                        <Image src={props.logo_path} style={{ width: 200, marginLeft: 6, maxHeight: '38px' }} />
                                    </a>
                                </Grid.Column>  

                            /*end of logo*/}

                            {/* Circuit Name */}
                            {
                                <>
                                    <Grid.Column width={4} className="middle aligned" style={{ bottom: 0, paddingBottom: 0 }} >
                                        {/* show for them */}

                                        {(circuit || title || action_name === 'lab') &&
                                            <>
                                                <CircuitName isSaving={isSaving} assignment={props.assignment ? props.assignment : null} circuit={circuit ? circuit : null} title={title} is_public={is_public} />
                                                {submission != null && submittedAt && <p style={{ color: "#ffffff", marginTop: "revert", fontSize: 11 }}>Answered at: {submittedAt} {submission.mark != null && <span style={{ fontWeight: 'bold', color: '#21ba45' }}>,mark: {submission.mark}</span>} </p>}
                                            </>
                                        }
                                    </Grid.Column>
                                </>
                            }
                            {is_labLoaded && !isSaving && circuit && circuit.is_experiment_created &&
                                <Grid.Column width={1}>
                                    <Button style={{ background: '#21BA45', color: '#ffffff' }} onClick={() => setShareOpen(true)}
                                        size='mini'><Icon name='share' />{l.share}</Button>
                                </Grid.Column>
                            }
                            {/* CREATOR CARD */}
                            {is_labLoaded && props.creator && props.creator.name != null && (user == null || props.creator.id != user.id) &&
                                <Grid.Column key="social" width={3} className="middle aligned" style={{backgroundColor: '0xff0000', bottom: 0, paddingBottom: 0 }}>
                                    <UserCard l={props.l} userProjects={userProjects} creator={props.creator} />
                                </Grid.Column>
                            }

                            {show_ic_creator && (<Grid.Column width={1}>
                                
                                <div style={{ position: 'relative' }}>
                                    <Button 
                                        style={{ background: '#2185D0', color: '#ffffff' }} 
                                        onClick={() => {
                                            if (typeof gtag === "function") {
                                                gtag("event", "integrated_circuit_builder", { "event_category": "Lab", "event_label": "In Lab"});
                                            }
                                            setIcCreatorOpen(true);
                                        }}
                                        size='mini'
                                    >
                                        <Icon name='microchip' />
                                        {l.integrated_circuit_builder}
                                        <div style={{ 
                                            position: 'absolute', 
                                            top: '-8px', 
                                            right: '-8px', 
                                            backgroundColor: '#FF4500', 
                                            color: 'white', 
                                            fontSize: '0.6rem', 
                                            padding: '2px 4px', 
                                            borderRadius: '4px', 
                                            fontWeight: 'bold',
                                            boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
                                        }}>
                                            {l.new}!
                                        </div>
                                    </Button>
                                </div>
                            
                            </Grid.Column>)}
                            {/* SAVE BUTTONS */}
                            
                            <Grid.Column key="saveButtons" width={(user && (props.creator && user.id == props.creator.id) || action_name == 'lab') ? 4 : 1} className="middle aligned" >
                                <>
                                    {show_save_buttons &&
                                        <>
                                            <Button color='orange' onClick={() => window.open("/lab", '_blank')}
                                                size='mini'>{l.new}</Button>
                                            <Button color='green'
                                                onClick={() => { onSave(false); }} size='mini'>{l.save}</Button>
                                            {title != undefined &&
                                                <Button color='green'
                                                    onClick={() => { onSave(true); }}
                                                    size='mini'>{l.save_as}</Button>
                                            }
                                            {userProjects != null && userProjects.length > 0 && <DropdownFile                                                
                                                userProjects={userProjects}                                                
                                            />}
                                            <Checkbox
                                            style={{ color: "#ffffff" }}
                                            onChange={(e, data) => setPublic(data.checked)}
                                            fitted
                                            label={
                                                <label style={{ display: 'flex', alignItems: 'center' }}>
                                                <p style={{ margin: 0, color: "#ffffff" }}>{l.public}</p>
                                                </label>
                                            }
                                            checked={is_public}
                                            />
                                            {user && user.class_rooms.length > 0 &&
                                                <ClassRooms selected_class_room_id={user.selected_class_room_id} class_rooms={user.class_rooms} />
                                            }
                                        </>
                                    }

                                </>

                            </Grid.Column>


                            {/*ASSIGNMENT BUTTONS*/}
                            {(is_labLoaded && action_name == 'assignment' && user != null && !props.isTeacher && (submittedAt === null || props.submission.assignment.settings.resubmit_allowed) && user && props.creator && submission && submission.user_id == user.id) && !isSaving &&
                                <Grid.Column key="AsignmentSaveButtons" width={2} className="middle aligned" style={{ bottom: 0, paddingBottom: 0 }}>
                                    <>
                                        <Button color='green'
                                            onClick={() => { 
                                                window.thumbs.refresh_current_thumb();                                                
                                                setTimeout(() => save(props.assignment.id), 1); 
                                                }} size='mini'>{l.save}</Button>
                                        {title != undefined &&
                                            <Button color='green'
                                                onClick={() => { showSubmitedAnswerDialog(true) }}
                                                size='mini'>{props.submission.submitted_at == null ? l.submit_answer : (props.submission.assignment.settings.resubmit_allowed ? l.resubmit_answer : l.submit_answer)}</Button>
                                        }
                                    </>
                                </Grid.Column>
                            }

                            {submission != null && submittedAt && props.isTeacher &&
                                <Grid.Column key="markButton" width={2} className="middle aligned" style={{ bottom: 0, paddingBottom: 0 }}>

                                    <Input
                                        disabled={isSaving}
                                        onKeyPress={(event) => {
                                            if (event.key == "Enter") {

                                                setTimeout(() => {
                                                    saveMark()
                                                }, 5)

                                            } else {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }
                                        }}
                                        style={{ width: 45 }}
                                        size='mini'
                                        action={{
                                            color: 'orange',
                                            labelPosition: 'left',
                                            icon: 'pencil',
                                            content: markCaption,
                                            onClick: () => saveMark()
                                        }}
                                        actionPosition='left'
                                        placeholder=''
                                        value={mark}
                                        defaultValue='0'
                                        onChange={(e, data) => {
                                            let v = data.value;
                                            if (v > 100) v = 100;
                                            setMark(v);
                                            setMarkCaption(l.save_mark);
                                        }
                                        }
                                    />

                                </Grid.Column>
                            }


                            <Grid.Column floated='right' key="login" width={4} style={{ 
                                paddingLeft: 0,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                height: '40px',
                                minWidth: 'fit-content',
                                zIndex: 9999                       
                            }}>
                                <div style={{ 
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    width: 'fit-content'
                                }}>
                                    <Grid.Column width={4} className="middle aligned" style={{paddingRight: 0 }}>
                                        <RightSection
                                            user={user}
                                            show_ai_chat={props.show_ai_chat}
                                            userMenu={Array.isArray(userMenu) ? userMenu : []}
                                            userMenuChange={userMenuChange}
                                            zoomValue={zoomValue}
                                            onZoomMenuChange={onZoomMenuChange}
                                            visible={visible}
                                            setVisible={setVisible}
                                            aiVisible={aiVisible}
                                            setAiVisible={setAiVisible}
                                            action_name={action_name}
                                            setIcCreatorOpen={setIcCreatorOpen}
                                        />
                                    </Grid.Column>
                                </div>
                            </Grid.Column>
                        </Grid.Row>                        

                    </Grid>
                </> /* end of top menu */}
                {/* SAMPLE CIRCUITS */}
                {!isEditingAssignment && <>
                    <Grid style={{ margin: 0, padding: 0, paddingTop: 14 }} id="internal-ad-off">
                        {action_name === 'lab' && (user == false || user == null) && !props.is_mobile && 
                         (props.featured_experiments.length > 0 || show_ads) &&
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <ShowOff 
                                        shining_ad={props.shining_ad} 
                                        show_ads={show_ads} 
                                        is_mobile={props.is_mobile} 
                                        featured_experiments={props.featured_experiments} 
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        }

                        {action_name === 'lab' && user && !props.is_mobile &&
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <SignedInAd show_ads={show_ads} />
                                </Grid.Column>
                            </Grid.Row>
                        }
                    </Grid>
                </>}

                {/* Lab And Description Side Grid */}
                <Grid id='lab-and-description-side' style={{                     
                    padding: 0, 
                    position: 'relative',
                    margin: 0,
                    width: '100%',
                    backgroundColor: background,
                    marginLeft: 0
                }}>
                    {/* THUMBS COLUMN */}
                    {(user || force_show_thumbs) && (
                        <div id='thumbs-div-id' style={{ 
                            width: !props.is_mobile ? '140px' : '0px',                            
                            position: 'absolute',
                            left: 0,
                            top: 6,
                            bottom: 0,
                            backgroundColor: background,
                            zIndex: 2,
                            overflow: 'auto',
                            visibility: !props.is_mobile ? 'visible' : 'hidden',
                            borderRight: !props.is_mobile ? '1px solid rgba(0,0,0,0.1)' : 'none',
                            marginTop: 0
                        }}>
                            <div style={{
                                width: '140px',
                                paddingTop: 0,
                                paddingRight: 25,
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <div style={{ flex: '1 1 auto' }}>
                                    <LeftPanel
                                        current_locale={current_locale}
                                        set_currentable_names={set_currentable_names}
                                        setPickedDCSweepSource={setPickedDCSweepSource}
                                        setMetricNodes={setMetricNodes}
                                        setSimulationError={setSimulationError}
                                        setZoomValue={setZoomValue}
                                        setDCSweepSources={setDCSweepSources}
                                        setAnalysisMode={setAnalysisMode}
                                        setCurrentMouseEvent={setCurrentMouseEvent}
                                        setInitialLocation={setInitialLocation}
                                        setChartLoading={setChartLoading}
                                        setInitialChecksSelected={setInitialChecksSelected}
                                        setCurrentSlide={setCurrentSlide}
                                        forecolor={forecolor}
                                        submission={submission}
                                        is_mobile={props.is_mobile}
                                        user={user}
                                        user_ics={user_ics}
                                        official_ics={official_ics}
                                        experiment_owner_ics={experiment_owner_ics}
                                        setNodes={setNodes}
                                        setVSweepValues={setVSweepValues}
                                        setSelectedVoltsValues={setSelectedVoltsValues}
                                        setSelectedAmperesValues={setSelectedAmperesValues}
                                        setVisible={setVisible}
                                        getDescription={() => {return description; }}
                                        setDescription={setDescription}
                                        getQuestion={() => { return question }}
                                        setQuestion={setQuestion}
                                        setLabLoaded={setLabLoaded}
                                        onLabLoaded={onLabLoaded}
                                        is_labLoaded={is_labLoaded}
                                        formattedTime={formattedTime}
                                        thresholdReached={thresholdReached}
                                        />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* MAIN CONTENT GRID */}
                    <Grid.Column 
                        width={16}
                        style={{ 
                            padding: 0,
                            margin: 0,
                            height: labHeight,
                            position: 'relative',
                            marginLeft: !props.is_mobile ? '140px' : 0,
                            marginTop: 0
                        }}
                    >
                        {/* Rest of the lab content */}
                        <Grid style={{ 
                            margin: 0,
                            height: '100%',
                            position: 'relative'
                        }}>
                            {/* LAB COLUMN */}
                            <Grid.Column 
                                width={visible || aiVisible ? 12 : (show_ads ? 14 : 16)}
                                style={{ 
                                    height: '100%',
                                    padding: 0,
                                    paddingTop: 0,
                                    margin: 0,
                                    position: 'relative'
                                }}
                            >
                                <div id="lab-div-id" style={{ 
                                    backgroundColor: 'white', 
                                    height: '100%',
                                    marginRight: visible || aiVisible ? 0 : (show_ads ? 15 : 0),
                                    width: '100%',
                                    position: 'relative'
                                }} />

                            {
                                
                                (action_name !== "iframe" && 
                                ((cta != null) || 
                                (!within_trial_period && !is_subscription_active && limitation))) &&                                 
                                <>                                
                                {!props.is_mobile && 
                                <ActionMessage cta={cta} 
                                setLimited={val => setLimited(val)}
                                setLimitation={val => setLimitation(val)} current_slide={currentSlide} l={l} limited={ (is_labLoaded && limited) || cta != null} />
                                }
                                </>
                            }


                            </Grid.Column>

                            {/* NOTES PANEL */}
                            {visible && !aiVisible && (
                                <Grid.Column width={4} style={{
                                    backgroundColor: '#ffffff',
                                    height: labHeight,
                                    overflowY: 'auto',
                                    boxShadow: '-2px 0 5px rgba(0,0,0,0.1)',
                                    padding: '1em',
                                    transition: 'all 0.3s ease'
                                }}>
                                    {(false && action_name != 'assignment' && !isEditingAssignment) && (
                                        <Button                                            
                                            icon="close"
                                            size="mini"
                                            style={{
                                                position: 'absolute',
                                                right: '0.5em',
                                                top: '0.5em',
                                                zIndex: 1
                                            }}
                                            onClick={() => setVisible(false)}
                                        />
                                    )}
                                    
                                    <SideTabs
                                        setVisible={setVisible}
                                        show_save_buttons={show_save_buttons}
                                        question_description={question}                                    
                                        description={description}
                                        labPageNotSigned={!is_user_signed_in && action_name == 'lab'}
                                        isCreator={action_name == 'lab' || props.creator && user && props.creator.id == user.id}
                                        isStudentAnswering={(action_name == 'assignment' && user != null && !props.isTeacher && (submittedAt === null || props.submission.assignment.settings.resubmit_allowed) && user && submission && submission.user_id == user.id)}
                                        setDescription={(c) => { setDescription(c); }}
                                        onSave={onSave}
                                        NGSpiceNetList={NGSpiceNetList} 
                                        isEditingAssignment={isEditingAssignment} 
                                        ngSpiceSelected={useNGSpice && (description == null || (description != null && description.length < 10)) && submission == null} 
                                        useNGSpice={useNGSpice && (submission == null || isTeacher)} 
                                    />
                                </Grid.Column>
                            )}

                            {/* AI PANEL */}
                            {(props.show_ai_chat || props.ai_chat_visible) && aiVisible && (
                                <Grid.Column width={4} style={{
                                    backgroundColor: '#ffffff',
                                    overflowY: 'auto',
                                    boxShadow: '-2px 0 5px rgba(0,0,0,0.1)',                                    
                                    paddingBottom: '0.1rem',
                                    transition: 'all 0.3s ease'
                                }}>
                                    {/* <Button
                                        icon="close"
                                        size="mini"
                                        style={{
                                            position: 'absolute',
                                            right: '0.5em',
                                            top: '0.5em',
                                            zIndex: 1
                                        }}
                                        onClick={() => setAiVisible(false)}
                                    /> */}
                                    {props.show_ai_chat && <AISideTabs 
                                        current_locale={current_locale}
                                        allow_chat={allow_chat}
                                        is_user_signed_in={is_user_signed_in}
                                        experiment_id={experiment_id}
                                        available_chats_count={available_chats_count}                                        
                                        is_paid_subscriber={is_paid_subscriber}
                                    />}
                                </Grid.Column>
                            )}
                        </Grid>
                    </Grid.Column>
                </Grid>

                {/* SUBMIT ANSWER DIALOG */}
                <Modal dimmer="inverted" size='small' open={submitAnswerDialogShown}>

                    <Modal.Header>{isResubmit() ? 'Resubmit' : 'Submit'} Your Assignment Now?</Modal.Header>

                    <Modal.Content>
                        <p>Are you sure you want to {isResubmit() ? 'resubmit' : 'submit'} your assignment?</p>
                        {props.submission != null && !props.submission.assignment.settings.resubmit_allowed &&
                            <p>You can not edit your work after submission.</p>
                        }
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => showSubmitedAnswerDialog(false)}>
                            No
                        </Button>
                        <Button onClick={() => {                                                    
                            window.thumbs.refresh_current_thumb();                                                    
                            setTimeout(() => submitAnswer(), 1);                                                     
                        }}>
                            Yes
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* SAVE DIALOG */}
                <Modal dimmer="inverted" size='small' open={isSaveOpened}>
                    <Header style={{backgroundColor: 'darkseagreen', color: 'darkslategray'}} icon='save' content={window.save_as ? l.save_as + ":" : l.save_circuit} />
                    <Form warning={isSaveSubmited && !validCircuitName(title)} id="save_form" error style={{ padding: 20 }} >
                        <Form.Field>
                            <label>{l.circuit_name}</label>
                            <Form.Input padding={20} autoFocus
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        save()
                                    }
                                }}
                                error={validCircuitName(title) ? false : isSaveSubmited ? true : false}
                                onChange={(e, data) => {
                                    setTitle(data.value);
                                }} style={{ borderRadius: '10px', width: '100%', height: 28, backgroundColor: 'khaki' }}
                                placeholder={l.circuit_name + '...'} value={title} />
                        </Form.Field>

                        <Message
                            warning
                            header={l.circuit_invalid_name}
                            list={[
                                l.circuit_name_0,
                                l.circuit_name_1
                            ]}
                        />


                        <Modal.Actions style={{ textAlign: 'right', paddingTop: 10 }}>

                            <Button style={{ visibility: 'hidden' }} />
                            <Button active={false} color='grey' onClick={(e) => { setSaveOpened(false); setTitle(titleBefore); }}>
                                {l.cancel}
                            </Button>
                            <Button active color='green' onClick={() => save()}>
                                {l.save}
                            </Button>
                        </Modal.Actions>

                    </Form>
                </Modal>





                {/* TRIED SAVING WHILE NOT SIGNED IT */}
                <Modal
                    basic
                    onClose={() => { setTriedToSave(2) }}
                    open={triedToSave == 1}
                    style={{backgroundColor: '#394755'}}
                    size='mini'
                >
                    <Header icon>
                        <Icon name='sign-in' />
                        {l.you_are_not_sigend_in}
                    </Header>
                    <Modal.Content>
                        <p>{l.create_account_to}</p>
                    </Modal.Content>
                    <Modal.Actions id="need_to_save_actions">
                        <Button color='green' onClick={() => { setTriedToSave(2); window.open("users/sign_in", "_blank"); }}>
                            {l.sign_in}
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* CUSTOM ERROR */}
                <Modal
                    centered
                    dimmer="inverted"
                    open={customErrorOpened}
                >
                    <Modal.Header>Maximum circuits number reached!</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <p>You can't save more than the number of circuits you have saved so far, contact us to ask for remove limitation.</p>
                            <p>Or you can remove some circuits that you don't need to keep and try again.</p>

                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => setCustomError(false)}>OK</Button>
                    </Modal.Actions>
                </Modal>




                {/* RE-TRY SAVING ERROR */}
                <Confirm
                    open={isRetryOpened}
                    confirmButton={l.retry}
                    onCancel={() => { setIsSaving(false), setRetryOpened(false) }}
                    content={isAnswering ? l.error_submit_answer : l.error_saving_circuit}
                    onConfirm={() => {
                        //retry answer? or retry save?
                        if (isAnswering)
                            submitAnswer(true)
                        else
                            save()
                    }}
                    size='small'
                />

                {/* Subscription Modal */}
                <SubscriptionModal
                    open={showSubscriptionModal}
                    onClose={() => setShowSubscriptionModal(false)}
                    isSecondaryThreshold={secondaryThresholdReached}
                    current_locale={current_locale}
                    onContinue={() => {
                        // Disable showing the modal for primary threshold
                        setShouldShowModalForPrimary(false);
                        
                        // If we're already past the secondary threshold, disable that too
                        if (elapsedTime >= SECONDARY_THRESHOLD) {
                            setShouldShowModalForSecondary(false);
                        }
                        
                        // Reset the thresholds in the hook
                        resetPrimaryThreshold();
                        if (elapsedTime >= SECONDARY_THRESHOLD) {
                            resetSecondaryThreshold();
                        }
                    }}
                />
                
                {/* IC Creator Modal */}
                {show_ic_creator && <Modal
                    open={isIcCreatorOpen}
                    onClose={() => {
                        // Close the modal
                        setIcCreatorOpen(false);
                        
                        // Fetch the ICs from the backend
                        axios.get('/api/ics/fetch_ics')
                            .then(response => {
                                const { official_ics, user_ics } = response.data;
                                
                                // Inject the ICs into the lab
                                if (window.com && window.com.clientside && window.com.clientside.main && window.com.clientside.main.Html5Bootstrap) {                                 
                                    window.com.clientside.main.Html5Bootstrap.jsCall("set_official_ics", official_ics);
                                    window.com.clientside.main.Html5Bootstrap.jsCall("set_user_ics", user_ics);
                                    com.clientside.main.Html5Bootstrap.jsCall("clear_ics");
                                }
                            })
                            .catch(error => {
                                console.error('Error fetching ICs:', error);
                            });
                    }}
                    size="large"
                    dimmer="inverted"
                    style={{
                        height: '95vh',
                        width: '90%',
                        margin: 'auto',
                        position: 'absolute',
                        top: '2.5%',
                        left: '5%',
                        borderRadius: '10px',
                        boxShadow: '0 12px 24px rgba(0,0,0,0.3)',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                    closeIcon={{ name: 'close', color: 'grey', style: { top: '10px', right: '10px', fontSize: '20px', cursor: 'pointer' } }}
                >
                    <Modal.Header style={{ 
                        borderBottom: '1px solid #eee',
                        padding: '10px 20px',
                        backgroundColor: '#f8f9fa',
                        borderTopLeftRadius: '10px',
                        borderTopRightRadius: '10px',
                        flex: '0 0 auto'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Icon name="microchip" size="large" style={{ marginRight: '10px', color: '#2185D0' }} />
                            <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#333' }}>{l.integrated_circuit_builder}</span>
                        </div>
                    </Modal.Header>
                    <Modal.Content style={{ 
                        padding: 0, 
                        flex: '1 1 auto',
                        height: 'calc(95vh - 70px)',
                        overflow: 'hidden',
                        backgroundColor: '#fff'
                    }}>
                        <IcCreatorWrapper user={user} setTriedToSave={setTriedToSave} current_locale={current_locale}/>
                    </Modal.Content>
                </Modal>
                }

            </>
        </PageVisibility>
    )

}

if (typeof window !== 'undefined') {
    window.LabLayout = LabLayout;
}

export default LabLayout;
